import styled from "styled-components";
import { borderRadius, fontWeights, mediaQueries, spacing, typographyMixin } from "@magicbi/ui-library";
import { LinkButton } from "../DistributionStepSection/DistributionStepSection.styles";

export const List = styled.dl`
  margin: 0;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.colors.border.subtle};
  border-radius: ${borderRadius.xl};
`;

export const Item = styled.div`
  display: grid;
  grid-template-columns: 10.625rem minmax(0, 1fr);
  align-items: start;
  gap: ${spacing[3]};
  padding: ${spacing[2]} ${spacing[4]};
  border-top: 1px solid ${({ theme }) => theme.colors.border.subtle};
  &:first-child {
    border-top: 0;
  }
  ${mediaQueries.down.sm} {
    grid-template-columns: minmax(0, 1fr);
    gap: ${spacing[0.5]};
  }
`;

export const Term = styled.dt`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  ${typographyMixin("body", 4)}
  font-weight: ${fontWeights.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  & > span[aria-hidden] {
    display: inline-flex;
    color: ${({ theme }) => theme.colors.text.link};
  }
  & > span[aria-hidden] > svg {
    width: 1rem;
    height: 1rem;
  }
`;

export const Description = styled.dd`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${spacing[3]};
  min-width: 0;
  margin: 0;
  ${typographyMixin("body", 4)}
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Bad = styled.span`
  font-weight: ${fontWeights.semibold};
  color: ${({ theme }) => theme.colors.error.text};
`;

export const Action = styled(LinkButton)`
  flex: none;
`;
